import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getAdvanced, getCssClasses } from '../../utils';
export default (node => {
  var props = _objectSpread(_objectSpread({
    display: node.style.display,
    text: node.textContent,
    textAlign: node.style.textAlign,
    openInNewTab: node.childNodes[0].getAttribute('target') === '_blank'
  }, getAdvanced(node.childNodes[0])), getCssClasses(node));
  var buttonType;
  if (node.childNodes[0].classList.contains('pagebuilder-button-secondary')) {
    buttonType = 'secondary';
  } else if (node.childNodes[0].classList.contains('pagebuilder-button-link')) {
    buttonType = 'link';
  } else {
    buttonType = 'primary';
  }
  props.buttonType = buttonType;
  if (node.childNodes[0].nodeName === 'A') {
    props.link = node.childNodes[0].getAttribute('href');
    props.linkType = node.childNodes[0].getAttribute('data-link-type');
  }
  return props;
});